import styled from '@emotion/styled';
import { css } from '@emotion/react';
import COLORS from 'styles/colors';

interface SelectedProps {
  isSelected?: boolean;
}

interface MonthDayProps {
  isOneTime?: boolean;
  isRecurringDate?: boolean;
  isSelected?: boolean;
  isStartDate?: boolean;
  isEndDate?: boolean;
  isInRange?: boolean;
  withResultDays?: boolean;
}

interface DayWrapperProps {
  isPast?: boolean;
}

export const MonthDay = styled.div<MonthDayProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2px;
  padding-left: 5px;
  width: 100%;
  padding-bottom: auto;
  height: 100%;
  position: relative;
  ${({ isStartDate, isEndDate, isOneTime }) =>
    css`
      ${isStartDate
        ? css`
            background: ${COLORS.cornflowerBlue};
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
            color: ${COLORS.white};
            height: calc(100% - 4px);
          `
        : ''}
      ${isEndDate
        ? css`
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          `
        : ''}
      ${isOneTime &&
      css`
        border-radius: 8px;
      `}
    `}
  ${({ isInRange }) =>
    isInRange &&
    css`
      background: ${COLORS.cornflowerBlueOpacity40};
      height: calc(100% - 4px);
      color: ${COLORS.gray900};
    `}
  ${({ isRecurringDate }) =>
    isRecurringDate &&
    css`
      background: ${COLORS.cornflowerBlue};
      color: ${COLORS.white};
      padding-top: 0px;
      padding-left: 2px;
      z-index: 1;
      height: calc(100% - 4px);
    `}
`;

export const DayWrapper = styled.div<DayWrapperProps>`
  position: relative;
  margin: 0px;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ isPast }) =>
    isPast
      ? css`
          width: 100%;
          cursor: not-allowed;
          background: ${COLORS.grey10};
          color: ${COLORS.grey60};
        `
      : null};
`;

export const Selected = styled.div<SelectedProps>`
  display: ${({ isSelected }) => (isSelected ? 'flex' : 'none')};
  position: absolute;
  width: 20px;
  height: 18px;
  border-bottom-left-radius: 8px;
  border-top-right-radius: 8px;
  right: 0;
  padding-right: 4px;
  top: 0;
  justify-content: center;
  align-items: center;
  background-color: ${COLORS.cornflowerBlue};
`;

export const SelectedIcon = styled.img`
  width: 12px;
`;
